import ICommand from "@/types/interfaces/i-command";

export default class RootState {
    commands: ICommand[] = [];
    isOffline = !navigator.onLine;
}